<!-- Start: Rejwan: 09-02-2026 Front Routes -->
<template>
    <div>
        <b-modal size="lg" id="bv-modal-process-settlement" dialog-class="w-1200 title-alignment" hide-footer :title="'Settlement for '+employee_name" >
                       {{ onAmountChange }}
                    <b-overlay  :show="showoverlaymodal" class='showoverlay_settle' rounded="sm">
                        <!-- <div class="d-flex"> -->
                        <div class="row">
                            <div class="col-md-8">
                                <b-form  class="settlement-form">                    
                                    <div class="clearfix">   
                                        <div class="row clearfix">
                                        <div class="col-md-12 float-left">
                                            
                                            <div class="d-flex" style="font-size: 13px;">
                                                <div class='text-left mb-4 col-md-6' >
                                                    <span ><span style="color: #004242; font-weight: 500;">Settlement ID: </span> {{settlement_fdata.settlement_company_code}}</span>
                                                </div>
                                                
                                                <div class='text-right mb-4 col-md-6'>
                                                    <a href="#" class="px-3 py-1 border rounded" style="border:1px solid green !important; color: green;"  @click="getEmployeePfReport(employee_id)" >
                                                        <i class="far fa-file-excel mr-1"></i> 
                                                        Download Schedule
                                                    </a>
                                                    <span class="px-3 py-1 rounded ml-2" v-if="settlement_fdata.application_status==1" style="background: #00c177; color: #ffffff;">
                                                        Approved
                                                    </span>
                                                    <span class="px-3 py-1 rounded ml-2" v-if="settlement_fdata.application_status==6" style="background: #00c177; color: #ffffff;">
                                                        Approved
                                                    </span>
                                                    <span class="px-3 py-1 rounded ml-2" v-if="settlement_fdata.application_status==2" style="background: #e8b80f; color: #ffffff;">
                                                        Deferred
                                                    </span>
                                                    <span class="px-3 py-1 rounded ml-2" v-if="settlement_fdata.application_status== -1" style="background: #e8b80f; color: #ffffff;">
                                                        Awaiting Consent
                                                    </span>
                                                    <span class="px-3 py-1 rounded ml-2" v-if="settlement_fdata.application_status==5" style="background: #e8b80f; color: #ffffff;">
                                                        Applied: Level 2
                                                    </span>
                                                </div>
                                            </div>
                                         
            
                                            <div class="d-flex" style="font-size: 13px;">
                                                <div class="col-md-6 pr-0">
                                                    <b-form-group id="settlement_date-group" label="Settlement Application Date" label-for="settlement_date" class="required-field">
                                                        <b-input-group class="mb-3">
                                                            <b-form-input id="settlement_date" :disabled="auto_filled"  :state="validateState('settlement_date')" name="settlement_date" v-model="settlement_fdata.settlement_date"  type="text" placeholder="YYYY-MM-DD" autocomplete="off" v-validate="{required:true,date_format:'yyyy-MM-dd' }"  aria-describedby="settlement_date-feedback" data-vv-as="Date"></b-form-input>
                                                            <template v-if="settlement_fdata.settlement_status != 'Disbursed'">
                                                                <b-input-group-append><!-- Mustafijur: 24-08-2026 -->
                                                                    <b-form-datepicker id="settlement_date" button-only right locale="en-US" v-model="settlement_fdata.settlement_date" :min="date_min" :disabled="auto_filled"></b-form-datepicker>
                                                                </b-input-group-append>
                                                            </template>
                                                            <b-form-invalid-feedback id="settlement_date-feedback">{{ veeErrors.first('settlement_date') }}</b-form-invalid-feedback>
                                                        </b-input-group>
                                                    </b-form-group>
                                                    <b-form-group  id="settlement_type-group" label="Type of Settlement" class="required-field" label-for="settlement_type ">
                                                        <b-form-select 
                                                            id="settlement_type" name="settlement_type" data-vv-as="Type"  :state="validateState('settlement_type')" v-model="settlement_fdata.settlement_type"
                                                            :options="settlementOptions" :disabled="disable_amount" v-validate="{ required: true }">
                                                            </b-form-select>
                                                            <b-form-invalid-feedback id="settlement_type-feedback">{{ veeErrors.first('settlement_type') }}</b-form-invalid-feedback>
                                                    </b-form-group>  
                                                    
                                                    <b-form-group  id="settlement_reason-group" label="Reason for Settlement" class="required-field"    label-for="settlement_reason ">
                                                        <b-form-select 
                                                            id="settlement_reason" name="settlement_reason" :disabled="disable_amount"  @change="getSettlementSlabWiseData()" data-vv-as="Reason" :state="validateState('settlement_reason')" 
                                                            :options="settlementReasonOptions" v-model="settlement_fdata.reason" v-validate="{ required: true }">
                                                            </b-form-select>
                                                            <b-form-invalid-feedback id="settlement_reason-feedback">{{ veeErrors.first('settlement_reason') }}</b-form-invalid-feedback>
                                                    </b-form-group>  
                                                </div>
                                                <!-- Start: Rejwan: 09-02-2026 Front Routes -->
                                                <!-- <pf-settlement-employee-details :pageurl="$api_url" :employee_pf_data="employee_pf_data"></pf-settlement-employee-details> -->
                                                <pf-settlement-employee-details-front :pageurl="$api_url" :employee_pf_data="employee_pf_data"></pf-settlement-employee-details-front>
                                                <!-- Start: Rejwan: 09-02-2026 Front Routes -->
                                            </div>

                                            
                                                            
                                            <div class="card-body">
                                                <div class="employee-table-wrapper">
                                                    
                                                    <table class="employee-list-table dataTable table-overflow table-sticky">
                                                
                                                    <thead>
                                                    <tr class="table-head">
                                                        <td class="text-center">
                                                            Particulars
                                                        </td>
                                                        <template v-if="settlement_fdata.application_status_label != 'Settled'">
                                                             <td class="text-center">
                                                                Balance
                                                            </td>
                                                        </template>
                                                       
                                                        <td class="text-center">
                                                        Settlement Amount <!-- Mustafijur: 23-08-2026 -->
                                                        </td>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr  class="hover-bg table-row">
                                                        <td class="text-left">
                                                            Employer’s contribution to PF
                                                        </td>
                                                        <template v-if="settlement_fdata.application_status_label != 'Settled'">
                                                             <td class="text-right">
                                                                {{ formatMoney(Math.max(0, employee_pf_data.pf_contribution_company)) }}
                                                            </td>
                                                        </template>
                                                       
                                                        <td class="text-right">
                                                            <b-form-group id="salary_contribution_employer-group"  class="required-field settlement_field_trz" label-for="salary_contribution_employer">
                                                            
                                                            <!-- Start: Rejwan: 24-04-2025 2 decimal -->
                                                            <!-- <b-form-input id="salary_contribution_employer"  :state="validateState('salary_contribution_employer')" :disabled="disable_amount" name="salary_contribution_employer" v-model="settlement_fdata.company_pf" v-validate="{ required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.pf_contribution_company)}" aria-describedby="salary_contribution_employer-feedback" data-vv-as=" Employer’s contribution to PF " ></b-form-input> -->

                                                            <b-form-input class="position-relative" v-if="!disable_amount" id="salary_contribution_employer"  :state="validateState('salary_contribution_employer')"  name="salary_contribution_employer" v-model="settlement_fdata.company_pf" v-validate="{ required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.pf_contribution_company)}" aria-describedby="salary_contribution_employer-feedback" data-vv-as=" Employer’s contribution to PF " ></b-form-input><!-- Mustafijur: 23-08-2026 -->
                                                            
                                                            <b-form-input class="position-relative" v-else id="salary_contribution_employer" :value="formatMoney(settlement_fdata.company_pf)" disabled></b-form-input><!-- Mustafijur: 23-08-2026 -->
                                                            <!-- End: Rejwan: 24-04-2025 2 decimal -->
                                                            <b-form-invalid-feedback id="salary_contribution_employer-feedback">{{ veeErrors.first('salary_contribution_employer') }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </td>
                                                    </tr>
                                                    <tr  class="hover-bg table-row">
                                                        <td class="text-left"> 
                                                            Employee’s contribution to PF
                                                        </td>
                                                        <template v-if="settlement_fdata.application_status_label != 'Settled'">
                                                            <td class="text-right">
                                                                {{ formatMoney(Math.max(0, employee_pf_data.pf_contribution_employee)) }}
                                                            </td>
                                                        </template>
                                                        
                                                        <td class="text-right">
                                                            <b-form-group id="salary_contribution_employee-group"  class="required-field settlement_field_trz" label-for="salary_contribution_employee">

                                                            <!-- Start: Rejwan: 24-04-2025 2 decimal -->
                                                            <!-- <b-form-input id="salary_contribution_employee" :state="validateState('salary_contribution_employee')" :disabled="disable_amount" name="salary_contribution_employee" v-model="settlement_fdata.employee_pf" v-validate="{ required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.pf_contribution_employee)}" aria-describedby="salary_contribution_employee-feedback" data-vv-as=" Employee’s contribution to PF " ></b-form-input> -->

                                                            <b-form-input class="position-relative" v-if="!disable_amount" id="salary_contribution_employee" :state="validateState('salary_contribution_employee')" name="salary_contribution_employee" v-model="settlement_fdata.employee_pf" v-validate="{ required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.pf_contribution_employee)}" aria-describedby="salary_contribution_employee-feedback" data-vv-as=" Employee’s contribution to PF " ></b-form-input><!-- Mustafijur: 23-08-2026 -->

                                                            <b-form-input class="position-relative" v-else id="salary_contribution_employee" :value="formatMoney(settlement_fdata.employee_pf)" disabled></b-form-input><!-- Mustafijur: 23-08-2026 -->
                                                            <!-- End: Rejwan: 24-04-2025 2 decimal -->
                                                            <b-form-invalid-feedback id="salary_contribution_employee-feedback">{{ veeErrors.first('salary_contribution_employee') }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </td>
                                                    </tr>
                                                    <tr  class="hover-bg table-row">
                                                        <td class="text-left">
                                                            Profit balance on employer’s contribution
                                                        </td>
                                                        <template v-if="settlement_fdata.application_status_label != 'Settled'">
                                                            <td class="text-right">
                                                                {{ formatMoney(Math.max(0, employee_pf_data.pf_profit_company)) }}
                                                            </td>
                                                        </template>
                                                        
                                                        <td class="text-right">
                                                            
                                                            <b-form-group id="profit_contribution_employer-group" class="required-field settlement_field_trz" label-for="profit_contribution_employer">

                                                            <!-- Start: Rejwan: 24-04-2025 2 decimal -->
                                                            <!-- <b-form-input id="profit_contribution_employer"  :state="validateState('profit_contribution_employer')" :disabled="disable_amount" name="profit_contribution_employer" v-model="settlement_fdata.company_profit" v-validate="{ required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.pf_profit_company)}" aria-describedby="profit_contribution_employer-feedback" data-vv-as=" Profit balance on employer’s contribution " ></b-form-input> -->

                                                            <b-form-input class="position-relative" v-if="!disable_amount" id="profit_contribution_employer"  :state="validateState('profit_contribution_employer')" name="profit_contribution_employer" v-model="settlement_fdata.company_profit" v-validate="{ required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.pf_profit_company)}" aria-describedby="profit_contribution_employer-feedback" data-vv-as=" Profit balance on employer’s contribution " ></b-form-input><!-- Mustafijur: 23-08-2026 -->

                                                            <b-form-input class="position-relative" v-else id="profit_contribution_employer" :value="formatMoney(settlement_fdata.company_profit)" disabled></b-form-input><!-- Mustafijur: 23-08-2026 -->
                                                            <!-- End: Rejwan: 24-04-2025 2 decimal -->

                                                            <b-form-invalid-feedback id="profit_contribution_employer-feedback">{{ veeErrors.first('profit_contribution_employer') }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </td>
                                                    </tr>
                                                    <tr  class="hover-bg table-row">
                                                        <td class="text-left">
                                                            Profit balance on employee’s contribution
                                                        </td>
                                                        <template v-if="settlement_fdata.application_status_label != 'Settled'">
                                                            <td class="text-right">
                                                                {{ formatMoney(Math.max(0, employee_pf_data.pf_profit_employee)) }}
                                                            </td>
                                                        </template>
                                                        
                                                        <td class="text-right">
                                                            <b-form-group id="profit_contribution_employee-group" class="required-field settlement_field_trz" label-for="profit_contribution_employee">

                                                            <!-- Start: Rejwan: 24-04-2025 2 decimal -->
                                                            <!-- <b-form-input id="profit_contribution_employee" :state="validateState('profit_contribution_employee')" :disabled="disable_amount" name="profit_contribution_employee" v-model="settlement_fdata.employee_profit" v-validate="{ required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.pf_profit_employee)}" aria-describedby="profit_contribution_employee-feedback" data-vv-as=" Profit balance on employee’s contribution" ></b-form-input> -->

                                                            <b-form-input class="position-relative" v-if="!disable_amount" id="profit_contribution_employee" :state="validateState('profit_contribution_employee')" name="profit_contribution_employee" v-model="settlement_fdata.employee_profit" v-validate="{ required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.pf_profit_employee)}" aria-describedby="profit_contribution_employee-feedback" data-vv-as=" Profit balance on employee’s contribution" ></b-form-input><!-- Mustafijur: 23-08-2026 -->
                                                            <b-form-input class="position-relative" v-else id="profit_contribution_employee" :value="formatMoney(settlement_fdata.employee_profit)" disabled></b-form-input><!-- Mustafijur: 23-08-2026 -->

                                                            <!-- End: Rejwan: 24-04-2025 2 decimal -->
                                                            <b-form-invalid-feedback id="profit_contribution_employee-feedback">{{ veeErrors.first('profit_contribution_employee') }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </td>
                                                    </tr>
                                                    <tr  class="hover-bg table-row">
                                                        <td class="text-left">
                                                            Forfeiture balance on employer’s contribution
                                                        </td>
                                                        <template v-if="settlement_fdata.application_status_label != 'Settled'">
                                                            <td class="text-right">
                                                                {{ formatMoney(Math.max(0, employee_pf_data.pf_forfeiture_company)) }}
                                                            </td>
                                                        </template>
                                                        
                                                        <td class="text-right">

                                                            <b-form-group id="forfeiture_contribution_employer-group" class="required-field settlement_field_trz" label-for="forfeiture_contribution_employer">

                                                            <!-- Start: Rejwan: 24-04-2025 2 decimal -->

                                                            <!-- <b-form-input id="forfeiture_contribution_employer"   :state="validateState('forfeiture_contribution_employer')" :disabled="disable_amount" name="forfeiture_contribution_employer" v-model="settlement_fdata.company_forfeiture" v-validate="{ required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.pf_forfeiture_company)}" aria-describedby="forfeiture_contribution_employer-feedback" data-vv-as=" Forfeiture balance on employer’s contribution" ></b-form-input> -->

                                                            <b-form-input class="position-relative" v-if="!disable_amount" id="forfeiture_contribution_employer" :state="validateState('forfeiture_contribution_employer')" name="forfeiture_contribution_employer" v-model="settlement_fdata.company_forfeiture" v-validate="{ required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.pf_forfeiture_company)}" aria-describedby="forfeiture_contribution_employer-feedback" data-vv-as=" Forfeiture balance on employer’s contribution" ></b-form-input><!-- Mustafijur: 23-08-2026 -->

                                                            <b-form-input class="position-relative" v-else id="forfeiture_contribution_employer" :value="formatMoney(settlement_fdata.company_forfeiture)" disabled></b-form-input> <!-- Mustafijur: 23-08-2026 -->
                                                            <!-- End: Rejwan: 24-04-2025 2 decimal -->
                                                            <b-form-invalid-feedback id="forfeiture_contribution_employer-feedback">{{ veeErrors.first('forfeiture_contribution_employer') }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                            
                                                        </td>
                                                    </tr>
                                                    <tr  class="hover-bg table-row">
                                                        <td class="text-left">
                                                            Forfeiture balance on employee’s contribution
                                                        </td>
                                                        <template v-if="settlement_fdata.application_status_label != 'Settled'">
                                                            <td class="text-right">
                                                                {{ formatMoney(Math.max(0, employee_pf_data.pf_forfeiture_employee)) }}
                                                            </td>
                                                        </template>
                                                        
                                                        <td class="text-right">
                                                        <b-form-group id="forfeiture_contribution_employee-group" class="required-field settlement_field_trz" label-for="forfeiture_contribution_employee">

                                                            <!-- Start: Rejwan: 24-04-2025 2 decimal -->
                                                            <!-- <b-form-input id="forfeiture_contribution_employee"   :state="validateState('forfeiture_contribution_employee')" :disabled="disable_amount" name="forfeiture_contribution_employee" v-model="settlement_fdata.employee_forfeiture" v-validate="{required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.pf_forfeiture_employee)}" aria-describedby="forfeiture_contribution_employee-feedback" data-vv-as=" Forfeiture balance on employee’s contribution" ></b-form-input> -->

                                                            <b-form-input class="position-relative" v-if="!disable_amount" id="forfeiture_contribution_employee"   :state="validateState('forfeiture_contribution_employee')" name="forfeiture_contribution_employee" v-model="settlement_fdata.employee_forfeiture" v-validate="{required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.pf_forfeiture_employee)}" aria-describedby="forfeiture_contribution_employee-feedback" data-vv-as=" Forfeiture balance on employee’s contribution" ></b-form-input> <!-- Mustafijur: 23-08-2026 -->
                                                            <b-form-input class="position-relative" v-else id="forfeiture_contribution_employee" :value="formatMoney(settlement_fdata.employee_forfeiture)" disabled></b-form-input> <!-- Mustafijur: 23-08-2026 -->
                                                            
                                                            <!-- End: Rejwan: 24-04-2025 2 decimal -->
                                                            <b-form-invalid-feedback id="forfeiture_contribution_employee-feedback">{{ veeErrors.first('forfeiture_contribution_employee') }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </td>
                                                    </tr>
                                                    
                                                    <tr  class="hover-bg table-row">
                                                        <td class="text-left">
                                                            Outstanding Advance Balance
                                                        </td>
                                                        <template v-if="settlement_fdata.application_status_label != 'Settled'">
                                                            <td class="text-right">
                                                                ({{ formatMoney(Math.max(0, employee_pf_data.loan_adjustable)) }})
                                                            </td>
                                                        </template>
                                                        
                                                        <td class="text-right">
                                                            ({{formatMoney(settlement_fdata.loan)}})
                                                        </td>
                                                    </tr>
                                                    <tr  class="hover-bg table-row">
                                                        <td class="text-left">
                                                            Outstanding Service Charge
                                                        </td>
                                                        <template v-if="settlement_fdata.application_status_label != 'Settled'">
                                                            <td class="text-right">
                                                                ({{ formatMoney(Math.max(0, employee_pf_data.service_charge_payable)) }})
                                                            </td>
                                                        </template>
                                                        
                                                        <td class="text-right">
                                                            ({{formatMoney(settlement_fdata.service_charge)}})
                                                        </td>
                                                    </tr>
                                                
                                                    <!-- //  -->
                                                    <template v-if="action_type == 'resubmit'">
                                                        <tr class="hover-bg table-row mx-2" v-for="(row, index) in adjustment_entries">
                                                            <td class="text-left pl-2 pr-2">
                                                                    <span v-on:click="removeElement(index);" class="border rounded px-3 py-2"><b-icon class="delete-btn-red" icon="trash-fill" role="button" aria-hidden="true" scale="1.2" ></b-icon></span>
                                                                    <b-form-select 
                                                                        v-model="row.adjustment_id" 
                                                                        :options="settlementDamageOptions" style="width: 85%;" >
                                                                    </b-form-select>
                                                            </td>
                                                            <td class="text-right">
                                                                Less
                                                            </td>
                                                            <td class="text-right">
                                                                <b-form-group  class="required-field settlement_field_trz" >
                                                                    <b-form-input v-model="row.value"  ></b-form-input>
                                                                </b-form-group>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    <template v-else>
                                                        <tr class="hover-bg table-row mx-2" v-for="(row, index) in adjustment_entries">
                                                            <td class="text-left">
                                                                {{showSelectedAdjustment(row.adjustment_id)}}
                                                            </td>

                                                            <td class="text-right" v-if="settlement_fdata.application_status_label != 'Settled'">
                                                                Less
                                                            </td>
                                                            <td class="text-right">
                                                                <b-form-group  class="required-field settlement_field_trz" >
                                                                    <b-form-input :disabled="disable_amount" v-model="row.value" ></b-form-input>
                                                                </b-form-group>
                                                            </td>
                                                        </tr>
                                                    </template>

                                                    
                                                    
                                                    <!-- //  -->

                                                    <tr class="hover-bg table-row" style="background: #cbe7e4 !important;">

                                                        <template v-if="settlement_fdata.application_status_label != 'Settled'">
                                                            <td class="text-left">
                                                                Net Payable
                                                            </td>
                                                            <td class="text-right">
                                                                <!-- {{formatMoney(employee_pf_data.closing_balance)}} --> <!-- Rejwan: 23-06-2026 -->
                                                                <!-- {{formatMoney(employee_pf_data.pf_net_payable_amount)}} --> <!-- Rejwan: 23-06-2026 -->
                                                                 {{ formatMoney(displayNetPayable) }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{formatMoney(settlement_fdata.settlement_amount)}}
                                                            </td>
                                                        </template>
                                                        <template v-else>
                                                            <td class="text-left">
                                                                Settlement Amount
                                                            </td>
                                                            <td class="text-right">
                                                                {{formatMoney(settlement_fdata.settlement_amount)}}
                                                            </td>
                                                        </template>
                                                    </tr> 
                                                    </tbody>
                                                    </table> 
                                                    <!-- <template v-if="action_type == 'resubmit'"> --> <!-- Start: Rejwan: 04-06-2025 Pf Settlement -->
                                                    <template v-if="action_type == 'resubmit' && is_balance_adjustment"> <!-- Start: Rejwan: 04-06-2025 Pf Settlement -->
                                                        <div class="trz-feedback mt-4 " style="display:flex !important;" >
                                                            <div class="col-md-4 pl-0 pr-0"><b-button class="border rounded bg-light py-1 px-5" @click="addRow" variant="primary">Add Balance Adjustment</b-button></div>
                                                            <div class="col-md-8 pl-2 pr-0">* Please enter the settlement amount based on the balance available and in accordance with your trust deed.</div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="trz-feedback mt-3">                                                            
                                                            <div class="col-md-12 pl-2 pr-0">* Balance Adjustment Item Payable to Company.</div>
                                                        </div>
                                                    </template>
                                                    
                                                    <div class="d-flex">
                                                        <div class="col-md-4 pl-0 pr-0"></div>
                                                        <div class="col-md-8 pl-2 pr-0 mt-3">
                                                            <div class="trz-invalid-feedback" style="display:block !important;" v-if="this.pf_from_disable==true" >{{settlement_disable_msg}}</div>
                                                        </div>
                                                    </div>
                                                    
                                                    <b-form-group  id="settlement_details-group" label="Remarks" class="required-field" label-for="settlement_details">
                                                        <b-form-textarea id="settlement_details"  :disabled="disable_amount" :state="validateState('settlement_details')" name="settlement_details" v-model="settlement_fdata.details" v-validate="{ required: true }" rows="3" max-rows="6"  no-resize   aria-describedby="settlement_details-feedback" data-vv-as="Remarks"></b-form-textarea>
                                                        <b-form-invalid-feedback id="settlement_details-feedback">{{ veeErrors.first('settlement_details') }}</b-form-invalid-feedback>
                                                    </b-form-group>


                                                    <a v-if="settlement_fdata.id > 0" href="javascript:void(0);" class="btn mb-2 btn-primary d-inline-block px-4"  @click="showAttachments()" >View Attachments</a>
                                        

                                                    <template v-if="settlement_fdata.settlement_type == 0 && settlement_fdata.reason > 0 && employee_pf_data.waived_profit > 0">

                                                        <table class="employee-list-table dataTable table-overflow table-sticky pt-4">

                                                            <thead>
                                                            <tr class="table-head">
                                                                <td colspan="3">Adjustment of Waived Profit as per Settlement Policy</td>
                                                            </tr>
                                                            
                                                            <tr class="table-head">
                                                                <td class="text-center">
                                                                    Component
                                                                </td>
                                                                <td class="text-center">
                                                                    Balance
                                                                </td>
                                                                <td class="text-center">
                                                                    Amount *
                                                                </td>
                                                            </tr>
                                                            </thead>
                                                            <tbody>

                                                                <tr  class="hover-bg table-row">
                                                                    <td class="text-left">
                                                                        Waived Profit: Employer
                                                                    </td>
                                                                    <td class="text-right">
                                                                        {{formatMoney(employee_pf_data.waived_profit_employer)}}
                                                                    </td>
                                                                    <td class="text-right">
                                                                        
                                                                        <b-form-group id="profit_contribution_employer_waived-group" class="required-field settlement_field_trz" label-for="profit_contribution_employer_waived">
                                                                        <b-form-input id="profit_contribution_employer_waived" :state="validateState('profit_contribution_employer_waived')" :disabled="disable_amount" name="profit_contribution_employer_waived" v-model="settlement_fdata.company_profit_waived" v-validate="{ required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.waived_profit_employer)}" aria-describedby="profit_contribution_employer_waived-feedback" data-vv-as=" Waived Profit: Employer " ></b-form-input>
                                                                        <b-form-invalid-feedback id="profit_contribution_employer_waived-feedback">{{ veeErrors.first('profit_contribution_employer_waived') }}</b-form-invalid-feedback>
                                                                        </b-form-group>
                                                                    </td>
                                                                </tr>


                                                                <tr  class="hover-bg table-row">
                                                                    <td class="text-left">
                                                                        Waived Profit: Employee
                                                                    </td>
                                                                    <td class="text-right">
                                                                        {{formatMoney(employee_pf_data.waived_profit_employee)}}
                                                                    </td>
                                                                    <td class="text-right">
                                                                        
                                                                        <b-form-group id="profit_contribution_employee_waived-group" class="required-field settlement_field_trz" label-for="profit_contribution_employee_waived">
                                                                        <b-form-input id="profit_contribution_employee_waived" :state="validateState('profit_contribution_employee_waived')" :disabled="disable_amount" name="profit_contribution_employee_waived" v-model="settlement_fdata.employee_profit_waived" v-validate="{ required: true,regex: /^[0-9]*\.?[0-9]{0,2}$/,max_value:Math.ceil(employee_pf_data.waived_profit_employee)}" aria-describedby="profit_contribution_employee_waived-feedback" data-vv-as=" Waived Profit: Employee " ></b-form-input>
                                                                        <b-form-invalid-feedback id="profit_contribution_employee_waived-feedback">{{ veeErrors.first('profit_contribution_employee_waived') }}</b-form-invalid-feedback>
                                                                        </b-form-group>
                                                                    </td>
                                                                </tr>

                                                            </tbody>
                                                        </table>
                                                        </template>
                                                </div> 
                                            </div>    

                                        
                                        </div>  
                                    </div>                           
                                    </div>
                                    <template v-if="action_type == 'resubmit'">
                                        <b-overlay  :show="showoverlayapproval" class='showoverlay_settle' rounded="sm">
                                            <div class="ibox">
                                                <div class="ibox-content p-3"> 
                                                    <div class="py-3" style="font-size: 13px;">
                                                    <div class="text-center modal-title"><h5 class="modal-title">Approval</h5></div>
                                                        <div class="d-flex py-3">
                                                            <div class="col-md-6 pl-0">Current approval Level: {{ settlement_fdata.application_status_label }}</div>
                                                            <div class="col-md-6 text-right pr-0">
                                                                <b-button class="employee-filter-btn  custom-primary-btn" @click="showApprovalHistoryNew()">  Approval History</b-button>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex">
                                                            <!-- <template v-if="settlement_fdata.last_approval_details">
                                                                {{settlement_fdata.last_approval_details.date }}
                                                                </br>
                                                                {{settlement_fdata.last_approval_details.comment }}
                                                                </br>
                                                                {{settlement_fdata.last_approval_details.comment_by_name }}
                                                                
                                                            </template> -->
                                                        
                                                            <div class="col-md-4 mt-3 pl-0">
                                                                <!-- <b-form-group  id="settlement-status-group" label="Provide Decision" class="required-field"    label-for="settlement_type ">
                                                                        <b-form-select 
                                                                            id="approver_decision" name="approver_decision" data-vv-as="Decision" v-model="approver_decision" :state="validateState('approver_decision')" 
                                                                            :options="decision_option" v-validate="{ required: true }" >
                                                                            </b-form-select>
                                                                            <b-form-invalid-feedback id="approver_decision-feedback">{{ veeErrors.first('approver_decision') }}</b-form-invalid-feedback>
                                                                </b-form-group>   -->

                                                                <b-form-group id="settlement_date-group" label="Deferred On [YYYY_MM-DD]" label-for="settlement_date" v-if="settlement_fdata.last_approval_details">
                                                                    <b-input-group class="mb-3">
                                                                        <b-form-input id="settlement_date" :disabled="auto_filled"  :state="validateState('settlement_date')" name="settlement_date" v-model="settlement_fdata.last_approval_details.date"  type="text" placeholder="YYYY-MM-DD" autocomplete="off" v-validate="{required:true,date_format:'yyyy-MM-dd' }"  aria-describedby="settlement_date-feedback" data-vv-as="Date"></b-form-input>
                                                                        <template >
                                                                                <b-form-datepicker id="settlement_date" button-only right locale="en-US" v-model="settlement_fdata.last_approval_details.date" :min="date_min"></b-form-datepicker>
                                                                        </template>
                                                                        <b-form-invalid-feedback id="settlement_date-feedback">{{ veeErrors.first('settlement_date') }}</b-form-invalid-feedback>
                                                                    </b-input-group>
                                                                </b-form-group>

                                                            </div>
                                                            <div class="col-md-2 mt-3 pl-0"></div>  
                                                            <div class="col-md-6 mt-3 pr-0">
                                                                <b-form-group  id="last_approval_details-group" label="Deferment Remarks" label-for="last_approval_details" v-if="settlement_fdata.last_approval_details">
                                                                    <b-form-textarea id="last_approval_details" :disabled="auto_filled" :state="validateState('last_approval_details')" name="last_approval_details" v-model="settlement_fdata.last_approval_details.comment" v-validate="{ required: true }" rows="3" max-rows="6"  no-resize   aria-describedby="last_approval_details-feedback" data-vv-as="Details"></b-form-textarea>
                                                                    <b-form-invalid-feedback id="last_approval_details-feedback">{{ veeErrors.first('last_approval_details') }}</b-form-invalid-feedback>
                                                                </b-form-group>
                                                            </div>

                                                            
                                                        </div>
                                                        <div class="col-md-12 mt-3 pr-0">
                                                            <b-form-group  id="approver_remarks-group" label="Remarks" label-for="approver_remarks" class="required-field">
                                                                <b-form-textarea id="approver_remarks" :state="validateState('approver_remarks')" name="approver_remarks" v-model="approver_remarks" v-validate="{ required: true }" rows="3" max-rows="6"  no-resize   aria-describedby="approver_remarks-feedback" data-vv-as="Remarks"></b-form-textarea>
                                                                <b-form-invalid-feedback id="approver_remarks-feedback">{{ veeErrors.first('approver_remarks') }}</b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> 
                                        
                                        <template> 
                                            <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 18px;"> 
                                                <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" variant="primary" :disabled="pf_from_disable" @click="reSubmit()">Re-Submit</b-button> 
                                            </div>
                                            
                                        </template>
                                     </b-overlay>
                                    </template>
                                    <template v-else>
                                        <template v-if="settlement_fdata.application_id > 0">
                                            <!-- Start: Rejwan: 09-02-2026 Front Routes -->
                                            <!-- <pf-settlement-approval-section :pageurl="$api_url" :quick_view="quick_view" :action_type="action_type" :settlement_fdata="settlement_fdata" is_valid="is_valid" v-on:childToParent="approvalReturn"></pf-settlement-approval-section> -->
                                            <pf-settlement-approval-section-front :pageurl="$api_url" :quick_view="quick_view" :action_type="action_type" :settlement_fdata="settlement_fdata" is_valid="is_valid" v-on:childToParent="approvalReturn"></pf-settlement-approval-section-front>
                                            <!-- End: Rejwan: 09-02-2026 Front Routes -->
                                        </template>
                                    </template>
                                    


                                
                                </b-form> 
                                
                            </div>
                            <div class="col-md-4 loan-comments border-left">
                                <h5 class="modal-title">Recent Comments</h5>
                                <!-- <discussion-thread :pageurl="$api_url" :ref_id="settlement_fdata.id"  module="9" :company_id="settlement_fdata.company" :key="thread_key" ></discussion-thread> --> <!-- Rejwan: 30-06-2025 Download Discussion Document -->
                                 <!-- Start: Rejwan: 09-02-2026 Front Routes -->
                                <!-- <discussion-thread :pageurl="$api_url" :ref_id="settlement_fdata.id"  module="9" :company_id="settlement_fdata.company_id" :key="thread_key" ></discussion-thread> -->
                                <advance-settlement-discuss-discussion-thread-front :pageurl="$api_url" :ref_id="settlement_fdata.id"  module="9" :company_id="settlement_fdata.company_id" :key="thread_key" ></advance-settlement-discuss-discussion-thread-front>
                                <!-- End: Rejwan: 09-02-2026 Front Routes -->
                            </div>
                        </div>
                        
                    </b-overlay>
        </b-modal>

        <b-modal id="bv-modal-approval-history-new" size="lg" hide-footer title="Approval History">
            <div class="col-sm-12 mt-1 mb-1"> 
                <!-- Start: Rejwan: 09-02-2026 Front Routes -->
                <!-- <approval-history :pageurl="$api_url" :application_id="this.settlement_fdata.application_id"  module="9" :company_id='this.settlement_fdata.company_id' :key="thread_key" ></approval-history> -->
                <advance-settlement-approver-approval-history :pageurl="$api_url" :application_id="this.settlement_fdata.application_id"  module="9" :company_id='this.settlement_fdata.company_id' :key="thread_key" ></advance-settlement-approver-approval-history>
                <!-- End: Rejwan: 09-02-2026 Front Routes -->
            </div>               
        </b-modal> 
        <b-modal id="show_attachments" size="lg" hide-footer title="Application Files" scrollable>
            <!-- Start: Rejwan: 09-02-2026 Front Routes -->
            <!-- <pf-settlememt-documents :pageurl="this.$api_url" flg="1" :key="flg_key" :settlement_id="settlement_fdata.id"></pf-settlememt-documents> -->
            <pf-settlememt-documents-front :pageurl="this.$api_url" flg="1" :key="flg_key" :settlement_id="settlement_fdata.id"></pf-settlememt-documents-front>
            <!-- End: Rejwan: 09-02-2026 Front Routes -->
        </b-modal>
        
    </div>
</template>
<script>
    
    export default{ 
        
        mounted() {
            
            
        },
        props: ['flg','pageurl','settlement_id','employee_id','employee_name','quick_view','action_type'],
        components: {
           
        },
        data(){            
           
           
            return { 
                settlement_disable_msg:"Settlement Amount cannot be less than 0 or greater than net payable.",
                settlementOptions: [{text:'Select Settlement Type',value:null},{text:'Final Settlement',value:0}, {text:'Partial Settlement',value:1}],
                showoverlaymodal:true,
                disabled:true,
                auto_filled:true,
                is_valid:0,
                settlement_amount: 0,
                settlement_fdata : {
                  employee_id:0, 
                  id: 0,
                  settlement_amount: 0,
                  settlement_date: null, 
                  settlement_details:'',
                  settlement_status: null,  
                  settlement_type:null,
                  reason:null,
                  salary_contribution_employer:0,
                  salary_contribution_employee:0,
                  profit_contribution_employer:0,
                  profit_contribution_employee:0,
                  forfeiture_contribution_employer:0, 
                  forfeiture_contribution_employee:0, 
                  loan_adjustable:0,
                  service_charge_payable:0,                          
                },
                date_min:'',
                employee_pf_data:{
                    pf_contribution_employee:0,
                    pf_contribution_company:0,
                    pf_profit_employee:0,
                    pf_profit_company:0,
                    pf_forfeiture_employee:0,
                    pf_forfeiture_company:0,
                    loan_adjustable:0,
                    service_charge_payable:0,
                },
                showoverlayapproval:false,
                employee_slab_data:[],
                disable_amount:true,
                pf_from_disable:false,
                settlementreason : null,
                settlementReasonOptions : [],
                settlementDamageOptions : [],
                percentdata : [],
                adjustment_entries : [],
                thread_key:0,
                approver_remarks:'',
                approver_decision:null,
                decision_option: [{text:'Approve',value:1},{text:'Defer',value:2}, {text:'Reject',value:3}], 
                flg_key:0,
                is_balance_adjustment: false, // Rejwan: 04-06-2025 Pf Settlement
            }
        },
        methods:{
        
            showAttachments()
           {
               this.$bvModal.show('show_attachments');
               this.flg_key += 1;
           },
            // faroque code starts here   
            showApprovalHistoryNew(){
                this.thread_key +=1;
                this.$bvModal.show('bv-modal-approval-history-new');
            },
            approvalReturn: function()
            {
                this.$bvModal.hide('bv-modal-process-settlement');
                this.$emit('childToParent');
            },
            showSelectedAdjustment: function(value)
            {
                // Find the object with the given value
                const reason = this.settlementDamageOptions.find(item => item.value === value);
                
                // Return the text if found, otherwise return a default message
                return reason ? reason.text : "Reason not found";
            },
            addRow: function () 
            {
                this.adjustment_entries.push({adjustment_id:null,value:0
                });

                this.tmp++;
            },
            removeElement: function (index) {
                this.adjustment_entries.splice(index, 1);
            },
            getReasons: function()
            {            
                if(!this.checkNet()) return false;
                let currentObj = this;

                // Start: Rejwan: 04-06-2025 Pf Settlement
                let set_id = 0;
                if(this.action_type == 'resubmit') {
                    set_id = this.settlement_id;
                }
                // End: Rejwan: 04-06-2025 Pf Settlement

                // axios.get(this.$api_url+'/pf/settl-reasons').then(function(response){ // Rejwan: 04-06-2025 Pf Settlement
                // axios.get(this.$api_url+'/pf/settl-reasons', { // Start: Rejwan: 09-02-2026 Front Routes
                axios.get(this.$api_url_front+'/pf/settl-reasons', { // Start: Rejwan: 09-02-2026 Front Routes
                    params: {
                            'quick_view':1,
                            'settlement_id' : set_id,
                        }
                        // End: Rejwan: 04-06-2025 Pf Settlement
                }).then(function(response){ // Rejwan: 04-06-2025 Pf Settlement
                                    
                    this.settlementReasonOptions = [{ value: null, text: "Select Settlement Reason" } ] . concat(response.data.policyreason);
                    this.settlementDamageOptions = [{ value: null, text: "Select Adjustment Reason" } ] . concat(response.data.adjreason);
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            
            getSettlementSlabWiseData : function()
            {
            	let formData = {};
                let currentObj = this;
            	
            	formData['settlementreason'] = this.settlementreason;
            	formData['service_period'] = this.employee_pf_data.service_period; 
            	formData['membership_period'] = this.employee_pf_data.membership_period; 
            	
            	formData['pf_contribution_employee'] = this.employee_pf_data.pf_contribution_employee; 
            	formData['pf_contribution_company'] = this.employee_pf_data.pf_contribution_company; 
            	
            	formData['pf_profit_company'] = this.employee_pf_data.pf_profit_company; 
            	formData['pf_profit_employee'] = this.employee_pf_data.pf_profit_employee; 
            	
            	// axios.post(this.$api_url+'/pf/settl-slabdata', formData) // Start: Rejwan: 09-02-2026 Front Routes
            	axios.post(this.$api_url_front+'/pf/settl-slabdata', formData) // Start: Rejwan: 09-02-2026 Front Routes
                    .then(function (response) 
                    { 
                      
                      let percentdata = response.data;
                      currentObj.settlement_fdata.company_pf = percentdata.employer_contr;
                      currentObj.settlement_fdata.employee_pf = percentdata.employee_contr;
                      currentObj.settlement_fdata.company_profit = percentdata.employer_profit;
                      currentObj.settlement_fdata.employee_profit = percentdata.employee_profit;
                      
                        
                    }.bind(this))
                    .catch(function (error) 
                    {                          
                                            
                      currentObj.serverError(error);
                    });
            },
          
            // faroque code ends here

     
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // },  
            toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return 0;
            },
            deregistrationSubmit(e) 
            {
                
                
            },
            processSettlement: function(employee_id)
            {

                let currentObj = this;
                
                // axios.get(this.$api_url+'/pf/employee/data' , { // Start: Rejwan: 09-02-2026 Front Routes
                axios.get(this.$api_url_front+'/pf/employee/data' , { // Start: Rejwan: 09-02-2026 Front Routes
                    params: {
								employee_id: employee_id,
							}
    
                }).then(function(response){ 

                    this.employee_pf_data = response.data;
                    this.getSettlementApplicationData(this.settlement_id);
                    

                    //this.settlement_fdata.loan = this.curr_emp_loan_total;

                    }.bind(this)).catch(function (error){
                    
                    console.log(error)
                });
                
                
            },
            handleInput()
            {
                this.$validator.validateAll().then(result => { 
                        console.log(result); 
                    if (!result) { 
                        
                        return;
                    }
                    
                    });
            },
            getSettlementApplicationData: function(settlement_id)
            {
                let currentObj = this;
                
                let formData = new FormData();
                formData.append('id', settlement_id);
                // axios.post(this.$api_url+'/pf/settlement/details', formData) // Start: Rejwan: 09-02-2026 Front Routes
                axios.post(this.$api_url_front+'/pf/settlement/details', formData) // Start: Rejwan: 09-02-2026 Front Routes
                .then(function (response) 
                {
                    currentObj.settlement_fdata = response.data;
                    currentObj.thread_key += 1; 
                    currentObj.adjustment_entries = currentObj.settlement_fdata.adjustment_entries; 
                    currentObj.showoverlaymodal = false; 
                });
            },
            getEmployeePfReport: function(employee_id)
            { 
            if(employee_id>0){
            var curr_obj = this;
            
            let formData = new FormData();
            formData.append('employee_id', employee_id); 
            formData.append('d_type', 'excel'); 
            this.loader = true;
            // axios.post(this.$api_url + '/pf/report/profile', formData) // Start: Rejwan: 09-02-2026 Front Routes
            // axios.post(this.$api_url_front + '/pf/report/profile', formData) // Start: Rejwan: 09-02-2026 Front Routes
            //                     .then(function (response) 
            //                     {
            //                         this.loader = false;
                                    
            //                         this.download_file(response.data.file_name);
            //                     }.bind(this))
            //                     .catch(function (error) 
            //                     {
            //                         currentObj.errormsg = error.response.data.errors;
            //                     }); 
                this.downloadBlobResponse(
                    axios.post(this.$api_url_front + '/pf/report/profile', formData, { responseType: 'blob' }),
                    'loader' // your loader key in this component
                );

                }

            }, 
            download_file(fileURL) 
            {
                if(!this.checkNet()) return false;
                
                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }    
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            reSubmit()
            {
                let settle_data = this.settlement_fdata;
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => { 
                    if (!result) { 
                        return;
                    } 
                    
                    let currentObj = this; 
                    currentObj.showoverlayapproval = true;
                    let formData = new FormData();
                    formData.append('settlement_id', settle_data.id);
                    formData.append('employee_id', settle_data.employee_id);
                    formData.append('company_id', settle_data.company_id);
                    formData.append('approval_application_id', settle_data.application_id );
                    formData.append('approval_user_type', 0 );
                    formData.append('approval_approver_id', 0);
                    formData.append('approval_comment', this.approver_remarks); 
                    formData.append('approval_module', 9);
                    
                    // axios.post(this.$api_url+'/approver/re-submit', formData) // Start: Rejwan: 09-02-2026 Front Routes
                    axios.post(this.$api_url_front+'/approver/re-submit', formData)// Start: Rejwan: 09-02-2026 Front Routes 
                    .then(function (response) 
                    {
                        currentObj.$bvToast.toast('Success', {
                            title: `Success`,
                            variant: 'success',
                            solid: true 
                        });
                        currentObj.showoverlayapproval = false; 
                        
                        currentObj.$bvModal.hide('bv-modal-process-settlement');
                        currentObj.$emit('childToParent');
                    });
                });
                
            },
            
        },
        created: function(){
        
          this.getReasons();
          
          if(this.settlement_id > 0 && this.employee_id > 0)
          {
            if(this.action_type == 'resubmit')
            {
                this.disable_amount = false;
            }

            setTimeout(() => {
                this.$bvModal.show('bv-modal-process-settlement');
                this.processSettlement(this.employee_id); 
            }, 1000);
            
          } 
        },
        computed: 
        {
            onAmountChange()
            {
            
                if(this.settlement_id > 0 && this.action_type == 'resubmit')
                {
                    
                
                    this.settlement_fdata.settlement_amount =  0; 
                    this.settlement_amount = 0;
                    this.settlement_amount += parseFloat(this.settlement_fdata.company_pf);
                    this.settlement_amount += parseFloat(this.settlement_fdata.employee_pf);
                    this.settlement_amount += parseFloat(this.settlement_fdata.company_profit);
                    this.settlement_amount += parseFloat(this.settlement_fdata.employee_profit);
                    this.settlement_amount += parseFloat(this.settlement_fdata.company_forfeiture);
                    this.settlement_amount += parseFloat(this.settlement_fdata.employee_forfeiture);
                    this.settlement_amount -= parseFloat(this.settlement_fdata.loan);
                    this.settlement_amount -= parseFloat(this.settlement_fdata.service_charge);

                    this.adjustment_entries.forEach(element => {

                        if(element.value != '' && element.value != undefined)
                        {
                            this.settlement_amount -= parseFloat(element.value);
                        }
                        
                        
                    });

                    if(this.settlement_amount < 0 || this.settlement_amount > this.employee_pf_data.closing_balance)
                    {
                        this.pf_from_disable = true;
                        this.settlement_fdata.settlement_amount =  this.settlement_amount;
                    } 
                    else
                    {
                        this.pf_from_disable = false;
                        this.settlement_fdata.settlement_amount =  this.settlement_amount;
                    } 
                }
                
                 
            },
            displayNetPayable() {
                if(this.$atl_company_number_format == 'no') {
                    var sumOfRounded = 
                        Math.round(this.employee_pf_data.pf_contribution_employee) +
                        Math.round(this.employee_pf_data.pf_contribution_company) +
                        Math.round(this.employee_pf_data.pf_profit_employee) +
                        Math.round(this.employee_pf_data.pf_profit_company) +
                        Math.round(this.employee_pf_data.pf_forfeiture_employee) +
                        Math.round(this.employee_pf_data.pf_forfeiture_company);

                    var original = Math.round(this.employee_pf_data.pf_net_payable_amount);
                    return sumOfRounded > original ? sumOfRounded : original;
                }
                return this.employee_pf_data.pf_net_payable_amount;
                
            },
        }
    }
</script>
<style scoped>
#bv-modal-process-settlement .form-control {
    z-index: 9;
}
#bv-modal-process-settlement .form-control.is-valid {
	padding-right: .75rem !important;
    z-index: 9;
}

</style>
<!-- End: Rejwan: 09-02-2026 Front Routes -->
